<section class="toast__title mat-body-small">
	@if (title()) {
			<span>{{ title() }}</span>
	} 
	@else if(localizedTitle()){
			<span>{{ localizedTitle()!.defaultText| translate : localizedTitle()!.translationToken : localizedTitle()!.translationScope}}</span>
  }
</section>

@if (text()) {
			<span>{{ text() }}</span>
} 
@else if(localizedText()){
		<span>{{ localizedText()!.defaultText| translate : localizedText()!.translationToken : localizedText()!.translationScope}}</span>
}
